import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service from "src/modules/data-protection/apis/DataFlowV2Service";

export const SOFTWARE_DATA_FLOWS_V2_QUERY_KEY = "software-data-flows-v2";

export const invalidateSoftwareDataFlowsV2 = (queryClient) => {
    return queryClient.invalidateQueries({
        queryKey: [SOFTWARE_DATA_FLOWS_V2_QUERY_KEY],
        refetchType: "active",
    });
};

const EMPTY_GROUPS = {
    receives_from: [],
    sends_to: [],
    relations: [],
};

const useSoftwareDataFlowsV2 = ({ softwareId, t } = {}) => {
    return useQuery({
        queryKey: [SOFTWARE_DATA_FLOWS_V2_QUERY_KEY, softwareId],
        queryFn: async () => {
            const service = DataFlowV2Service.getInstance();
            const response = await service.getSoftwareDataFlows(softwareId);

            return response?.data || EMPTY_GROUPS;
        },
        enabled: Boolean(softwareId),
        cacheTime: 0,
        staleTime: 0,
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching data flows."), {
                type: "error",
            });
        },
    });
};

export default useSoftwareDataFlowsV2;
